import { ChangeDetectionStrategy, Component, computed, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';

function paramDeger(ek: any, ismi: string): any {
  const diziden = ek?.parametreler?.find((p: any) => p.ismi === ismi)?.degeri;
  if (diziden != null) return diziden;
  return ek?.[ismi] ?? '';
}

@Component({
  selector: 'ariza-kaydi-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzInputNumberModule, NzDatePickerModule, NzSelectModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="mk-edit">
      <div class="mk-baslik">
        <div class="mk-baslik-ikon" style="background:linear-gradient(135deg,#dc2626,#f87171)">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
        </div>
        <span>Arıza Kaydı</span>
      </div>
      <div class="mk-form">
        <div class="form-satir">
          <div class="form-grup">
            <label>Arıza Türü <span class="zorunlu">*</span></label>
            <div class="input-wrap">
              <nz-select [ngModel]="deger('arizaTuru') || 'Mekanik'" (ngModelChange)="guncelle('arizaTuru', $event)" style="width:100%">
                <nz-option nzValue="Mekanik" nzLabel="Mekanik" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#3b82f6"></span>Mekanik</span></nz-option>
                <nz-option nzValue="Elektrik" nzLabel="Elektrik" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#f59e0b"></span>Elektrik</span></nz-option>
                <nz-option nzValue="Hidrolik" nzLabel="Hidrolik" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#8b5cf6"></span>Hidrolik</span></nz-option>
                <nz-option nzValue="Pnömatik" nzLabel="Pnömatik" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#0d9488"></span>Pnömatik</span></nz-option>
                <nz-option nzValue="Yazılım" nzLabel="Yazılım" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#ec4899"></span>Yazılım</span></nz-option>
                <nz-option nzValue="Diğer" nzLabel="Diğer" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#94a3b8"></span>Diğer</span></nz-option>
              </nz-select>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup">
            <label>Tarih</label>
            <div class="input-wrap">
              <nz-date-picker [ngModel]="deger('tarih')" (ngModelChange)="guncelle('tarih', $event)" style="width:100%" nzFormat="dd.MM.yyyy"></nz-date-picker>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>
        <div class="form-satir">
          <div class="form-grup">
            <label>Süre (Saat)</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="deger('sure') || 0" (ngModelChange)="guncelle('sure', $event)" [nzMin]="0" [nzStep]="0.5" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup">
            <label>Maliyet (TL)</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="deger('maliyet') || 0" (ngModelChange)="guncelle('maliyet', $event)" [nzMin]="0" [nzStep]="0.01" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>
        <div class="form-grup">
          <label>Çözüm</label>
          <div class="input-wrap">
            <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')" [ngModel]="deger('cozum')" (ngModelChange)="guncelle('cozum', $event)" placeholder="Uygulanan çözüm..."/>
            <div class="input-glow"></div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    :host { display: block; }
    .mk-edit { display: flex; flex-direction: column; padding: 0; }
    .mk-baslik { display: flex; align-items: center; gap: 10px; padding: 12px 16px; margin-bottom: 4px; border-radius: 10px; background: linear-gradient(135deg, var(--py-arkaplan-soluk, rgba(0,0,0,0.03)), transparent); }
    .mk-baslik-ikon { width: 32px; height: 32px; border-radius: 8px; display: flex; align-items: center; justify-content: center; color: #fff; flex-shrink: 0; box-shadow: 0 2px 8px rgba(220,38,38,0.35); }
    .mk-baslik span { font-size: 13px; font-weight: 600; color: var(--py-metin, #333); letter-spacing: 0.3px; }
    .mk-form { display: flex; flex-direction: column; gap: 14px; padding: 4px 2px; }
    .form-satir { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
    .form-grup { display: flex; flex-direction: column; gap: 5px; }
    .form-grup label { font-size: 11px; font-weight: 500; color: var(--py-metin-ucuncul, rgba(0,0,0,0.45)); text-transform: uppercase; letter-spacing: 0.6px; padding-left: 2px; transition: color 0.2s; }
    .form-grup:focus-within label { color: var(--py-link, #1890ff); }
    .zorunlu { color: #ff4d4f; font-size: 13px; line-height: 1; vertical-align: middle; }
    .input-wrap { position: relative; }
    .input-glow { position: absolute; bottom: 0; left: 50%; width: 0; height: 2px; border-radius: 1px; background: linear-gradient(90deg, #dc2626, #f87171, #dc2626); transition: width 0.35s cubic-bezier(0.4,0,0.2,1), left 0.35s cubic-bezier(0.4,0,0.2,1), opacity 0.3s; opacity: 0; pointer-events: none; z-index: 1; }
    .input-wrap:focus-within .input-glow { width: 100%; left: 0; opacity: 1; }
    .input-wrap input[nz-input] { background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)); border: 1px solid var(--py-kenarlik, #d9d9d9); border-radius: 8px; padding: 7px 11px; font-size: 13px; color: var(--py-metin, #333); transition: border-color 0.25s, background 0.25s, box-shadow 0.25s; }
    .input-wrap input[nz-input]:focus { border-color: var(--py-kenarlik-aktif, #1890ff); background: var(--py-input-arka, #fff); box-shadow: 0 0 0 2px rgba(220,38,38,0.1); outline: none; }
    .input-wrap ::ng-deep .ant-select-selector, .input-wrap ::ng-deep .ant-picker { background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)) !important; border: 1px solid var(--py-kenarlik, #d9d9d9) !important; border-radius: 8px !important; min-height: 34px; }
    .input-wrap ::ng-deep .ant-input-number { width: 100% !important; border-radius: 8px; }
    .ac-opt { display: flex; align-items: center; gap: 8px; }
    .ac-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
  `],
})
export class ArizaKaydiEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  deger(alan: string): any { return paramDeger(this.p(), alan); }
  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (!params?.ek) return;
    params.ek[alan] = deger;
    this.parametreler.set({ ...params });
  }
}
